<p>manage-equipement works!</p>
